define(function (require) {
	const Marionette = require('backbone.marionette');
	const PasswordResetItemView = require('./v_itv_login_passwordReset');
	const tpl = require('./templates/t_lov_login_passwordReset.hbs');

	return Marionette.LayoutView.extend({
		template: tpl,
		regions: {
			ResetItemViewRegion: '.user-login',
		},
		initialize: function (options) {
			this.config = options.config;
			this.modalContainer = options.modalContainer;
		},
		onRender: function () {
		},
		onShow: function () {
			var passwordResetItemView = new PasswordResetItemView({
				config: this.config,
				modalContainer:this.modalContainer
			});
			this.ResetItemViewRegion.show(passwordResetItemView);
		},
		templateHelpers: function () {
			return {};
		},
	});
});
